<template>
    <div class="root">
      <div class="title">流量套餐</div>
      <div class="balance" v-if="stockInfo.rechargeType==1">
        <span class="text-1">卡积分：</span><span class="text-2"> {{stockInfo.balance}}分</span>
        <span  class="text-3" @click="rechargeBalance">充值</span>
      </div>
      <div class="package-list">
        <template v-if="groupedSections.length>0">
          <div class="package-section" v-for="section in groupedSections" :key="section.type">
            <!--<div class="section-title">{{ section.title }}</div>-->
            <div class="package-group" v-for="group in section.groups" :key="section.type + '-' + group.key">
              <div class="group-title">{{ group.title }}</div>
              <div class="group-grid">
                <div
                  class="package-item"
                  v-for="item in group.items"
                  :key="item.id"
                  :class="{'color1':item.month<12,'color2':item.month==12,'color3':item.month>12}"
                >
                  <div class="head">
                    <div class="package-title">{{ item.title}}</div>
                    <div class="price">
                      <span class="icon">&yen;</span>
                      <span>{{item.price}}</span>
                    </div>
                  </div>
                  <div class="desc">
                    {{item.desc}}
                  </div>
                  <div class="expire">{{ item.startDate }}-{{ item.endDate }}</div>
                  <div class="bottom">
                    <div class="btn" @click="checkPackage(item),createOrder()">立即{{stockInfo.rechargeType==1?'兑换':'订购'}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="empty">
          没有可充值的套餐
        </div>
      </div>
      <div class="tips">
        <div class="tp-title">温馨提示</div>
        <ul class="tp-content">
          <li>网络服务由当地优质运营商提供，安全靠谱</li>
          <li>购买后 30 天之内随时启用，有效期将从启用后开始计算，每 24 小时计为1天，一经启用，无法暂停计时</li>
          <li>购买后使用 30 天以内，可在公众号联系客服取消订单在海岛、隧道、山区、高速公路、沙漠等偏远地区，受限于运营商网络覆盖，可能会出现信号较弱和信号丢失的情况</li>
          <li>开启热点共享时，建议关闭接入手机的同步、备份等功.能，避免套餐流量消耗过快</li>
        </ul>
      </div>
    </div>
</template>

<script>
    export default {
        name: "recharge",
        data() {
            return {
                iccid:'',
                packageID:0,
                //packageList:[],
                packageGroup:[],
                one:{},
                stockInfo:{},
                tips:[],
                operator:{},
                authRecharge:0,
            };
        },
        computed:{
            packages0(){
              return this.packageGroup[0] ? this.packageGroup[0] : []
            },
            groupedSections(){
              const makeGroups = (list) => {
                const filtered = (list || []).filter(i => i)
                if (!filtered.length) return []
                const map = {}
                const order = []
                for (const item of filtered) {
                  const rawKey = (item.typeName && String(item.typeName).trim()) ? String(item.typeName).trim() : '其他套餐'
                  const key = rawKey
                  if (!map[key]) {
                    map[key] = { key, title: rawKey, items: [] }
                    order.push(key)
                  }
                  map[key].items.push(item)
                }
                return order.map(k => map[k])
              }

              const sec0 = makeGroups(this.packages0)
              const sections = []
              if (sec0.length) sections.push({ type: 0, title: '本月流量', groups: sec0 })
              return sections
            },
            hasAnyPackages(){
              return (this.packages0 && this.packages0.length)
            }

        },
        watch:{},
        methods: {
            queryPackageList(type){
                this.$toast.loading()
                this.fetchData('/package/getRechargePackage',{iccid:this.iccid,type:type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$set(this.packageGroup ,type,res.data)
                        this.$forceUpdate()
                    }else{
                        this.packageGroup[type]=[]
                    }
                })
            },
            checkPackage(item){
                this.packageID = item.id
                this.one = item;
            },
        createOrder(){
                if(this.authRecharge == 0){
                    this.$toast('请实名后再续费,若已实名，请尝试刷新网页重试');
                    return false;
                }
                if(this.type == 0 && this.one.alertMsg){
                  this.$dialog.confirm({
                    title: '提示',
                    message: this.one.alertMsg
                  }).then(() => {
                    if(this.stockInfo.rechargeType==1) {
                        this.commitorderbalance()
                      }else {
                          this.commitorder()
                      }
                  }).catch(() => {
                    // on cancel
                  });
                }else{
                  if(this.stockInfo.rechargeType==1) {
                        this.commitorderbalance()
                      }else {
                          this.commitorder()
                      }
                }
            },
          commitorder(){
            this.$toast.loading({ forbidClick: true })
            this.fetchDataPost('/order/createOrder',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
              this.$toast.clear();
              if(res.code){
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', res.data,
                  (res)=>{
                    if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                      this.$toast.success('支付成功');
                      this.$router.push({name:'index',query:{iccid:this.iccid}})
                    }
                  }
                );
              }else{


                if(res.url){
                  if(res.msg) {
                    this.$dialog.confirm({
                      title: "提示",
                      message: res.msg
                    }).then(() => {
                      // on confirm
                      let query = {}
                      if (res.data) {
                        query = res.data
                      }
                      query.cardno = this.iccid
                      sessionStorage.removeItem('token');
                      this.$router.push({path: res.url, query: query})
                    }).catch(() => {
                      // on cancel
                    })
                  }else{
                    this.$router.push({path: res.url, query: res.data})
                  }
                }else {
                  if (res.msg.indexOf('appid') !== -1 && res.msg.indexOf('openid') !== -1) {
                    this.$toast.fail('登录失效，请尝试重新进入查询')
                    sessionStorage.clear()
                  } else {
                    this.$dialog.alert({
                      title: '提示',
                      message: res.msg,
                    }).then(() => {

                    });

                  }
                }


              }
            })
          },
	  commitorderbalance(){
      this.$toast.loading({ forbidClick: true })
                this.fetchDataPost('/order/createOrderbalance',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg)
                        setTimeout(res=>{
                            this.$router.back()
                        },1500)
                    }else{
                        this.$toast(res.msg)
                        if(res.msg && res.msg.indexOf("积分") !== -1){
                            setTimeout(res=>{
                                this.rechargeBalance()
                            },1500)

                        }
                    }

                })
            },
            rechargeBalance(){
                this.$router.push({name:"cardBalance",query: {iccid:this.iccid}})
            },

            getStockInfo(){
                this.fetchData('/card/info',{iccid:this.iccid},(res)=>{
                    this.stockInfo = res.data
                    if(this.stockInfo.amount > 0){
                        this.type = 1
                    }
                })
            },
            getTips(){
                this.fetchData('/card/tips',{iccid:this.iccid},(res)=>{
                    console.log(res.data)
                    this.tips = res.data.split("\n")
                })
            },
            getCardOperator(){
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        if(this.operator.activeRule == 1){
                            this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
                              console.log(res.data)
                                if (!res.data.simAuthStatus) {
                                    this.$dialog.alert({
                                        title: '实名提示',
                                        message: '请先完成实名',
                                    }).then(() => {
                                        // on close
                                        window.location.href = this.operator.authUrl
                                    });
                                }else{
                                    this.authRecharge = 1
                                }
                            })
                        }else{
                            this.authRecharge = 1
                        }
                    }
                })
            }
        },
        created: function () {
            let query = this.$route.query;
            this.iccid = query.iccid;
            this.getStockInfo()
            this.getCardOperator();
            // 只拉取本月套餐
            this.queryPackageList(0)
            this.getTips()
        }
    };
</script>
<style lang="scss" scoped>
.root{
  .tips{
    width: 6.9rem;
    margin: .4rem auto;
    color: #fff;
    .tp-title{
      font-size: .32rem;
    }
    .tp-content{
      margin-top: .26rem;
      margin-left: .32rem;
      li{
        line-height: .34rem;
        font-size: .26rem;
        margin-top: .1rem;
        list-style: square;
      }
    }
  }
  .balance{
    width: 3.64rem;
    background: #fff;
    text-align: center;
    padding: .12rem 0;
    margin: .3rem auto 0;
    .text-1{
      font-size: .30rem;
    }
    .text-2{
      font-size: .3rem;
      color: #3690e3;
    }
    .text-3{
      display: inline-block;
      background: #f2616b;
      border-radius: .08rem;
      color: #fff;
      padding: .06rem .14rem;
      margin-left: .16rem;
      line-height: 1;
      font-size: .3rem;
    }
  }
  height: inherit;
  font-size: 0;
  background: linear-gradient(180deg, #f05864,#f2616b);
  overflow-y: scroll;
  .package-list{
    box-sizing: border-box;
    *, *::before, *::after{
      box-sizing: border-box;
    }
    .empty{
      font-size: .36rem;
      color: #fff;
      text-align: center;
    }
    width: 6.9rem;
    margin:.3rem auto;
    .package-section{
      margin-bottom: .5rem;
      .section-title{
        font-size: .34rem;
        color: #fff;
        font-weight: 700;
        margin: 0 0 .22rem;
        padding-left: .08rem;
      }
      &:last-child{
        margin-bottom: 0;
      }
    }
    .package-group{
      margin-bottom: .34rem;
      .group-title{
        font-size: .3rem;
        color: #fff;
        font-weight: 600;
        margin: 0 0 .18rem;
        padding-left: .08rem;
      }
      .group-grid{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: .25rem;
        row-gap: .34rem;
        align-items: start;
      }
    }
    .package-item{
      width: auto;
      padding: .24rem .28rem;
      background: #fff;
      border-radius: .3rem;
      margin-bottom: 0;
      .head{
        .package-title{
          font-size: .32rem;
          color: #000;
          text-align: center;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          line-height: .42rem;
        }
        .price{
          margin-top: .14rem;
          text-align: center;
          white-space: nowrap;
          span{
            color: #f05864;
            font-size: .36rem;
            vertical-align: middle;
          }
          .icon{
            font-size: .2rem;
            border-width: 1px;
            border-style: solid;
            border-radius: 100%;
            display: inline-block;
            width: .2rem;
            height: .2rem;
            text-align: center;
            line-height: .2rem;
            vertical-align: middle;
            margin-right: .06rem;
          }
        }
      }
      &.color1{
        .head{
          .package-title{ color: #4EA6FFFF; }
          .price{
            span{ color: #4EA6FFFF; }
            .icon{ border-color: #4EA6FFFF; }
          }
        }
        .bottom .btn{ background: #4EA6FFFF; }
      }
      &.color2{
        .head{
          .package-title{ color: #F25764FF; }
          .price{
            span{ color: #F25764FF; }
            .icon{ border-color: #F25764FF; }
          }
        }
        .bottom .btn{ background: #F25764FF; }
      }
      &.color3{
        .head{
          .package-title{ color: #FF8A44FF; }
          .price{
            span{ color: #FF8A44FF; }
            .icon{ border-color: #FF8A44FF; }
          }
        }
        .bottom .btn{ background: #FF8A44FF; }
      }
      .desc{
        margin-top: .18rem;
        font-size: .24rem;
        color: #888;
        line-height: .34rem;
        min-height: .68rem; // 2 lines * 0.34rem
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .expire{
        margin-top: .12rem;
        margin-bottom: .08rem;
        text-align: center;
        font-size: .24rem;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1;
      }
      .bottom{
        margin-top: 0;
        .btn{
          display: block;
          width: 100%;
          color: #fff;
          font-size: .28rem;
          background: #f05864;
          text-align: center;
          height: .52rem;
          line-height: .52rem;
          border-radius: .12rem;
          white-space: nowrap;
        }
      }
    }
  }
  .title{
    font-size: .36rem;
    text-align: center;
    color: #fff;
    padding: .2rem 0 ;
   letter-spacing: .1rem;
  }
  .package-type{
    height: .7rem;
    display: flex;
    background: #fff;
    div{
      flex: 1;
      text-align: center;
      line-height: 1;
      color: #000;
      font-size: .32rem;
      display: inline-block;
      height: .32rem;
      margin-top: .19rem;
    }
    div.active{
      color: #f05864;
    }
    :first-child{
      border-right: 3px solid #000;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/recharge.vue